import type { UserType } from "@volgo/core/contract";
import { useState } from "react";

/** The account's Discord picture, or the first letter of the name when there is none or it fails to load. */
export function Avatar({ user }: { user: UserType }) {
  const [failed, setFailed] = useState(false);
  return (
    <span className="av" aria-hidden="true">
      {user.avatarUrl && !failed ? (
        <img src={user.avatarUrl} alt="" referrerPolicy="no-referrer" onError={() => setFailed(true)} />
      ) : (
        ([...user.username][0] ?? "?").toUpperCase()
      )}
    </span>
  );
}
